"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionDetails = exports.AccordionSummary = exports.Accordion = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var ArrowForwardIosSharp_1 = __importDefault(require("@mui/icons-material/ArrowForwardIosSharp"));
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
exports.Accordion = (0, styles_1.styled)(function (props) { return (react_1.default.createElement(Accordion_1.default, __assign({ disableGutters: true, elevation: 0, square: true }, props))); })(function () { return ({
    // border: `1px solid ${theme.palette.divider}`,
    border: 0,
    '& .Mui-expanded.MuiButtonBase-root': {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        border: 0
    },
    '&:not(:last-child)': {
        borderBottom: 0
    },
    '&:before': {
        display: 'none'
    }
}); });
exports.AccordionSummary = (0, styles_1.styled)(function (props) { return (react_1.default.createElement(AccordionSummary_1.default, __assign({ expandIcon: react_1.default.createElement(ArrowForwardIosSharp_1.default, { sx: { fontSize: '0.9rem' } }) }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        // flexDirection: 'row-reverse',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: theme.spacing(1),
            paddingRight: '4px'
        },
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            border: '1px solid #e1e1e1',
            borderRadius: theme.spacing(2),
            paddingRight: 0,
            marginRight: '12px'
        },
        fontSize: '1.1em',
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1)
        },
        borderBottom: "1px solid ".concat(theme.palette.divider)
    });
});
exports.AccordionDetails = (0, styles_1.styled)(AccordionDetails_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        borderBottom: "1px solid ".concat(theme.palette.divider),
    });
});
